const ruRU = require("../locale/ru-RU.json")
import elementLangRU from 'element-ui/lib/locale/lang/ru-RU'
const zhCN = require("../locale/zh-CN.json")
import elementLangCN from 'element-ui/lib/locale/lang/zh-CN'

export const RURU = 'ru-RU'
export const ZHCN = 'zh-CN'

export const LOCALE_SERVICES_MAP = {
  [RURU]: {
    main: ruRU,
    elementUI: elementLangRU,
    moment: 'ru',
    nominatim: 'ru',
    apiAcceptLanguage: 'ru-ru'
  },
  [ZHCN]: {
    main: zhCN,
    elementUI: elementLangCN,
    moment: 'zh-cn',
    nominatim: 'cn',
    apiAcceptLanguage: 'zh-cn'
  }
}

// process.env.LOCALE in build/webpack.base.conf.js in define plugin
export const LOCALE = (function () {
  const defaultLocale = process.env.LOCALE
  const storageValue = window.localStorage.getItem('LOCALE') ? JSON.parse(window.localStorage.getItem('LOCALE')) : null
  return storageValue || defaultLocale
}())

export const NOMINATIM_ACCEPT_LANGUAGE = LOCALE_SERVICES_MAP[LOCALE].nominatim

export const API_ACCEPT_LANGUAGE = LOCALE_SERVICES_MAP[LOCALE].apiAcceptLanguage
